var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(("font-size: " + (_vm.size + 'px') + ";")),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"100","viewBox":"0 0 100 100","fill":_vm.colorName}},[_c(_vm.name.split(' ').join(''),{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }